module.exports = __webpack_public_path__ + "img/measurement_dn.206b79d8.svg";